export function groupBy(list = [], key) {
  return list.reduce((acc, item) => {
    const groupKey = typeof key === 'function' ? key(item) : item[key];
    if (!acc[groupKey]) acc[groupKey] = [];
    acc[groupKey].push(item);
    return acc;
  }, {});
}

export function sortBy(list = [], key, direction = 'asc') {
  const sorted = [...list].sort((a, b) => {
    const valueA = typeof key === 'function' ? key(a) : a[key];
    const valueB = typeof key === 'function' ? key(b) : b[key];
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  });
  return direction === 'desc' ? sorted.reverse() : sorted;
}

export function sum(list = [], key) {
  return list.reduce(
    (total, item) => total + (typeof key === 'function' ? key(item) : item[key]),
    0
  );
}

export function toggleItem(list = [], value) {
  return list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
}

export function uniqueBy(list = [], key) {
  const seen = new Set();
  return list.filter((item) => {
    const value = typeof key === 'function' ? key(item) : item[key];
    if (seen.has(value)) return false;
    seen.add(value);
    return true;
  });
}
